import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const UpdatePlan = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setOpen(true); // open popup on page load
  }, []);

  const handleClose = () => {
    setOpen(false);
    navigate("/dashboard");
  };

  return (
    <div style={styles.page}>
      {open && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h2>Upgrade Required 🚀</h2>
            <p>
              Your current plan does not allow access to this feature.
              Please upgrade to <b>Starter</b> or <b>Pro</b>.
            </p>

            <div style={styles.buttons}>
                <button onClick={() => navigate("/billing")} style={styles.btnPrimary}>
  Upgrade Plan
</button>
              {/* <button onClick={handleClose} style={styles.btnPrimary}>
                Go to Dashboard
              </button> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdatePlan;

const styles = {
  page: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f5f5",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modal: {
    background: "#fff",
    padding: "30px",
    borderRadius: "12px",
    width: "400px",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  },
  buttons: {
    marginTop: "20px",
  },
  btnPrimary: {
    padding: "10px 20px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
};